import { FC } from 'react'
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuestion, selectQuiz } from 'store/quiz/quizSelectors';
import IQuestion from 'models/Question';
import IQuiz from 'models/Quiz';
import QuizTypes from 'types/QuizTypes';
import QuestionTypes from 'types/QuestionTypes';

type Props = {
  time: number;
}

const QuestionClue:FC<Props> = ({ time }) => {
  const { t } = useTranslation();

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const question:IQuestion = useAppSelector(selectQuestion);

  const questionTimeout = quiz.questionsSettings.timeout || 10;

  if (quiz.type !== QuizTypes.Scoring || question.type !== QuestionTypes.ShortText || !question.config?.clue) return null;
  if (time < (questionTimeout / 2)) return null;
  return (
    <div className="mt-4">
      <p className="text-sm text-primary text-center uppercase">{t('labels.clue')}</p>
      <p className="text-center font-bold" style={{ color: '#ff9100' }}>{question.config.clue}</p>
    </div>
  )
}

export default QuestionClue;
